<template>
  <div class="col-span-2 h-fit rounded-md bg-surface-elevation-2 p-8">
    <ChipBadge class="mb-4" color="yellow" rounded> {{ t('Reviews.badge.preview') }} </ChipBadge>
    <div class="border-solid border-main bg-surface p-6">
      <div class="mb-4 text-headline-xs">{{ label }}</div>
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
import { ChipBadge } from '@ramp106/omrjs-core-ui'
import { useI18n } from 'vue-i18n'

defineProps<{
  label: string
}>()
const { t } = useI18n()
</script>
